import { render, staticRenderFns } from "./AddPessoavinculoPage.vue?vue&type=template&id=079bb814"
import script from "./AddPessoavinculoPage.vue?vue&type=script&lang=js"
export * from "./AddPessoavinculoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports